import React, { SetStateAction } from "react";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import "./DropdownInput.scss";

interface Props {
  title?: string;
  placeholder?: string;
  options: string[];
  radio?: boolean;
  setOptions?: (option: any) => void;
}

export default function DropdownInput({
  title,
  placeholder,
  options,
  radio = true,
  setOptions,
}: Props) {
  const onChange = (e) => {
    setOptions?.(
      options.filter((value) => {
        return value !== e.value;
      })
    );
  };
  return (
    <div className={`DropdownElement ${radio && "radio"}`}>
      <div className="title">{title}</div>
      <Dropdown
        options={options}
        placeholder={placeholder}
        onChange={onChange}
      />
    </div>
  );
}
